'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border: 1px solid rgba(0,0,0,.75);\n'], ['\n  width: 100%;\n  border: 1px solid rgba(0,0,0,.75);\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Image = _styledComponents2.default.img(_templateObject);

/** @class ImageContent
  * A component for displaying an image.
  * @prop {url} image - the url of the image to display
  * @prop {string} caption - the caption of the image
  */

var ImageContent = function (_Component) {
  _inherits(ImageContent, _Component);

  /** @constructor
    * Constructs a new instance of ImageContent.
    */
  function ImageContent(props) {
    _classCallCheck(this, ImageContent);

    var _this = _possibleConstructorReturn(this, (ImageContent.__proto__ || Object.getPrototypeOf(ImageContent)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Opens the image in an overlay or follows its url
    */


  _createClass(ImageContent, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      if (this.props.url) {
        // Determine if this is an internal or external url
        if (this.props.url.indexOf('http://') === 0 || this.props.url.indexOf('https://') == 0) {
          // External link, open in new tab and log action
          window.open(this.props.url);
          if (window.vexpo && window.vexpo.log) window.vexpo.log('opened external link ' + this.props.url);
        } else {
          // Open internal link in this tab
          window.location = this.props.url;
        }
      } else if (window.vexpo && window.vexpo.overlay) window.vexpo.overlay(this.props);
    }
    /** @method
     * Renders the ImageContent.
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { onClick: this.handleClick, style: { "cursor": "pointer" } },
        _react2.default.createElement(Image, { src: this.props.image, alt: this.props.name }),
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.caption } })
      );
    }
  }]);

  return ImageContent;
}(_react.Component);

exports.default = ImageContent;


ImageContent.propTypes = {
  image: _propTypes2.default.string.isRequired,
  caption: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/image-content.js
// module id = 651
// module chunks = 0